import { IYmaps } from './types';
import { insertScriptToLoadYmaps } from './ymaps-loading';

export interface IYmapsApiInterface {
  loadYmaps(modules: string[]): Promise<IYmaps>;
}

export class YmapsApi implements IYmapsApiInterface {
  private ymapsP: Promise<IYmaps>;

  public loadYmaps(modules: string[]) {
    if (!this.ymapsP) {
      this.ymapsP = insertScriptToLoadYmaps();
    }

    return this.ymapsP.then(ymaps => ymaps.load(modules));
  }
}
